<div class="row justify-content-center mt-2 mb-1">
  <div class="col-md-6">
    <ul id="progressbar">
      <li [ngClass]="{'active': step === 1}">{{'TEXT.DOC-ISSUE' | translate}}</li>
      <li [ngClass]="{'active': step === 2}">{{'TEXT.CREATE-DOC' | translate}}</li>
      <li [ngClass]="{'active': step === 3}">{{'TEXT.DOC-IS-EMAIL' | translate}}</li>
    </ul>
  </div>
</div>

<div *ngIf="step === 0">
  <div class="row justify-content-center">
    <div class="col">

      <h4 class="header">
        {{'TEXT.TITLE-IS-DOC' | translate}}
      </h4>

      <div class="rowFix type-parent text-center">
        <div class="col-md-6" *ngFor="let type of customerTypes">
          <div class="type-option"
               (click)="selectCustomerType(type)">
            <img [src]="'../../../../assets/images/customer/' + type.type + '.png'" class="mr-4">
            {{ type.name }}
            <br>
            {{ type.nameEN }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="step === 1">
  <div class="row justify-content-center">
    <div class="col">

      <h4 class="header">
        {{'TEXT.TITLE-IS-DOC' | translate}}
      </h4>

      <div class="rowFix type-parent text-center">
        <div class="col-md-6" *ngFor="let template of documentTypes">
          <div class="type-option"
               (click)="selectDocumentType(template); checkDocumentNumber()">
            <img src="../../../../assets/images/csv.png" class="mr-4">
            {{ template.name }}
            <br>
            {{ template.nameEN }}
          </div>
        </div>
      </div>

    </div>
  </div>
</div>


<div *ngIf="step === 2">
  <div class="row justify-content-center">
    <div class="col">
      <h4 class="header">
        {{'ISSUE-TEXT.CREATE' | translate}} - {{ selectedDocumentType.name }}
      </h4>

      <div class="box-filter position-relative z-2">
        <div class="row row-eq-height">
          <div class="col-7">

            <div class="row align-items-center" *ngFor="let refInfo of data.referenceDocumentID; let i = index">
              <div class="col-1 p-b-15" *ngIf="selectedDocumentType.type != 'tax_invoice'">
                <button class="ui-button ui-button-icon-only" *ngIf="i === 0" (click)="addRefID()">
                  <i class="fa fa-plus"></i>
                </button>
              </div>

              <div class="p-b-15" [ngClass]="selectedDocumentType.type != 'tax_invoice' ? 'col-2' : 'col-3'">
                <label for="reference">{{'ISSUE-TEXT.REF-ID'|translate}}</label>
              </div>
              <div class="col-9 p-b-15">
                <input class="form-control" id="reference" [(ngModel)]="refInfo.refDocID">
                <span class="text-danger">{{ errorRefID }}</span>
              </div>

            </div>
          </div>

          <div class="col-4 offset-1">
            <div class="row align-items-center" *ngFor="let refInfo of data.referenceDocumentID; let i = index;">
              <div class="col-4 p-b-15">
                {{'ISSUE-TEXT.REF-DATE'|translate}}
              </div>

              <div class="p-b-15" [ngClass]="selectedDocumentType.type != 'tax_invoice' ? 'col-6' : 'col-8'">  <!-- TODO: fix this element's width -->
                <p-calendar [(ngModel)]="refInfo.refDate" readonlyInput="true"
                            [showIcon]="true" dateFormat="dd/mm/yy" [locale]="calendarLocale" [yearNavigator]="true"
                            yearRange="2000:2030"></p-calendar>

                <span class="text-danger">{{ errorRefDate }}</span>
              </div>
              <div class="col-1 p-b-15">
                <button class="ui-button bg-danger border-danger ui-button-icon-only" (click)="removeRefID(i)"
                        *ngIf="i !== 0">
                  <i class="fa fa-trash-alt"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="col-md-7">
            <div class="row align-items-center m-t-10 " *ngIf="selectedDocumentType.type != 'receipt_tax_invoice'">
              <div class="col-md-3">
                <label>{{'ISSUE-TEXT.RECEIVED-FROM'|translate}}</label>
              </div>
              <div class="col-md-9">
                <ng-select class="custom" [items]="newBuyerList"
                           id="receivedFrom"
                           bindLabel="name"
                           placeholder="Type to search..."
                           [(ngModel)]="data.buyer.receivedFrom"
                           [addTag]="true"
                           [addTagText]="'NORMAL.ADD'|translate"
                           (change)="selectReceivedFrom($event)">
                  <label for="receivedFrom">received from</label>
                </ng-select>
<!--                <p-autoComplete-->
<!--                  inputId="receivedFrom"-->
<!--                  [suggestions]="buyerList"-->
<!--                  field="name"-->
<!--                  [(ngModel)]="data.buyer.receivedFrom"-->
<!--                  (onSelect)="selectBuyer($event, true)"-->
<!--                  [minLength]="2"-->
<!--                  appendTo="body"-->
<!--                  [inputStyle]="{width: '100%', fontFamily: 'Kanit'}"-->
<!--                  class="dv-autocomplete"-->
<!--                  placeholder="Type to search..."-->
<!--                  emptyMessage="No buyer found"-->
<!--                  (completeMethod)="completeBuyerList($event,true)"></p-autoComplete>-->
                <span
                  class="text-danger">{{ errors.buyer && (errors.buyer.receivedFrom || errors.buyer['receivedFrom.name']) }}</span>
              </div>
            </div>

            <div class="row align-items-center m-t-10">
              <div class="col-md-3">
                <label for="customerID">{{'ISSUE-TEXT.CUSTOMER-ID'|translate}}</label>
              </div>

              <div class="col-md-9">
                <input class="form-control" id="customerID" [(ngModel)]="data.buyer.customerID">

                <span class="text-danger">{{ errors.buyer && errors.buyer.customer_id }}</span>
              </div>
            </div>

            <!--            <div class="row align-items-center m-t-10" *ngIf="isDomesticCorporation">-->
            <!--              <div class="col-md-3">-->
            <!--                <label for="branchName">{{'TABLE.BRANCH-NAME'|translate}}</label>-->
            <!--              </div>-->
            <!--              <div class="col-md-9">-->
            <!--                <div class="row">-->
            <!--                  <div class="col-md-7">-->
            <!--                    <input class="form-control" type="text" id="branchName" [(ngModel)]="data.buyer.branchName"-->
            <!--                           [disabled]="data.buyer.headOffice">-->
            <!--                  </div>-->

            <!--                  <div class="col-md-5">-->
            <!--                    <div class="form-label-group">-->
            <!--                      <p-checkbox class="dv-checkbox" binary="true" [(ngModel)]="data.buyer.headOffice"-->
            <!--                                  label="{{'DATA.HEAD-OFFICE'|translate}}"></p-checkbox>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </div>-->

            <!--                <div class="row" *ngIf="errors.buyer && errors.buyer.branchName">-->
            <!--                  <div class="col">-->
            <!--                    <span class="text-danger">{{ errors.buyer && errors.buyer.branchName }}</span>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->

            <div class="row align-items-center m-t-10">
              <div class="col-md-3">
                <label for="address">{{'FILTER.ADDRESS'|translate}}</label>
              </div>

              <div class="col-md-9">
                <textarea class="form-control" id="address" [(ngModel)]="data.buyer.address"></textarea>

                <span class="text-danger">{{ errors.buyer && errors.buyer.address }}</span>
              </div>
            </div>

            <div class="row align-items-center m-t-10">
              <div class="col-md-3">
                <label for="postCode">{{'DATA.DELIVERY-POSTALCODE'|translate}}</label>
              </div>

              <div class="col-md-9">
                <input class="form-control" type="text" id="postCode" [(ngModel)]="data.buyer.postCode">

                <span class="text-danger">{{ errors.buyer && errors.buyer.postCode }}</span>
              </div>
            </div>

            <div class="row align-items-center m-t-10">
              <div class="col-md-3">
                <label for="country">{{'DATA.COUNTRY'|translate}}</label>
              </div>

              <div class="col-md-9">
                <p-dropdown
                  class="dv-dropdown"
                  inputId="country"
                  [options]="countryList"
                  [(ngModel)]="data.buyer.country"
                  [autoDisplayFirst]="false"
                  appendTo="body"
                >
                </p-dropdown>

                <span class="text-danger">{{ errors.buyer && errors.buyer.country }}</span>
              </div>
            </div>

            <div class="row align-items-center m-t-10">
              <div class="col-md-3">
                <label for="taxID">
                  {{ isForeignCorporation ? 'Passport No.' : 'ISSUE-TEXT.TAX-ID'|translate }}
                </label>
              </div>

              <div class="col-md-9">
                <ng-select class="custom" [items]="newBuyerList"
                           id="taxID"
                           bindLabel="tax_id"
                           placeholder="Type to search..."
                           [(ngModel)]="data.buyer.taxID"
                           [addTag]="true"
                           [addTagText]="'NORMAL.ADD'|translate"
                           (change)="selectTaxID($event)">
                </ng-select>
                <span class="text-danger">{{ errorTaxId }}</span>
<!--                <p-autoComplete-->
<!--                  inputId="taxID"-->
<!--                  [suggestions]="buyerList"-->
<!--                  field="tax_id"-->
<!--                  [(ngModel)]="data.buyer.taxID"-->
<!--                  (onSelect)="selectBuyer($event, false)"-->
<!--                  [minLength]="2"-->
<!--                  appendTo="body"-->
<!--                  [inputStyle]="{width: '100%', fontFamily: 'Kanit'}"-->
<!--                  class="dv-autocomplete"-->
<!--                  placeholder="Type to search..."-->
<!--                  emptyMessage="No Buyer Tax ID found"-->
<!--                  (completeMethod)="completeBuyerList($event, false)"></p-autoComplete>-->
<!--                <span class="text-danger">{{ errorTaxId }}</span>-->
              </div>

            </div>

            <div class="row align-items-center m-t-10">
              <div class="col-md-3">
                <label for="branchCode">
                  {{'TABLE.BRANCH-CODE'|translate}}
                </label>
              </div>

              <div class="col-md-9">
                <!-- <input *ngIf="data.buyer === null" class="form-control" type="text" id="branchCode" [(ngModel)]="data.buyer.branchCode"> -->
                <ng-select class="custom" [items]="branchCodeList" id="branchCode" bindLabel="branch_code"
                  placeholder="Type to search..." [(ngModel)]="data.buyer.branchCode" [addTag]="true"
                  [addTagText]="'NORMAL.ADD'|translate"
                  (change)="selectBranchCode($event)">
                </ng-select>

<!--                <p-dropdown-->
<!--                  class="dv-dropdown"-->
<!--                  selectId="branchCode"-->
<!--                  [options]="branchCodeList"-->
<!--                  [(ngModel)]="data.buyer.branchCode"-->
<!--                  [autoDisplayFirst]="true"-->
<!--                  editable="true"-->
<!--                  [style]="{'font-family': 'Kanit'}"-->
<!--                >-->
<!--                </p-dropdown>-->

                <span class="text-danger">{{ errors.buyer && errors.buyer.branchCode }}</span>
              </div>
            </div>

            <div class="row align-items-center m-t-10">
              <div class="col-md-3">
                <label for="email">
                  {{'EMAIL-DASHBOARD.EMAIL'|translate}}
                </label>
              </div>

              <div class="col-md-9">
                <input class="form-control" type="text" id="email" [(ngModel)]="data.buyer.email">

                <span class="text-danger">{{ errors.buyer && errors.buyer.email }}</span>
              </div>
            </div>

            <div class="row align-items-center m-t-10">
              <!--              <div class="col-md-3">-->
              <!--                <label for="brokerName">-->
              <!--                  {{'ISSUE-TEXT.BROKER-NAME'|translate}}-->
              <!--                </label>-->
              <!--              </div>-->

              <!--              <div class="col-md-9">-->
              <!--                <input class="form-control" type="text" id="brokerName" [(ngModel)]="data.buyer.brokerName">-->
              <!--                <span class="text-danger">{{ errors.buyer && errors.buyer.brokerName }}</span>-->
              <!--              </div>-->
              <div class="col-md-3">
                <label>{{'ISSUE-TEXT.BROKER-NAME'|translate}}</label>
              </div>
              <div class="col-md-9">
                <input class="form-control" type="text" id="brokerName" [(ngModel)]="data.buyer.brokerName">
                <span class="text-danger">{{ errors.buyer && errors.buyer.brokerName }}</span>
              </div>
            </div>

            <div class="row align-items-center m-t-10">
              <div class="col-md-3">
                <label for="brokerEmail">
                  {{'ISSUE-TEXT.BROKER-EMAIL'|translate}}
                </label>
              </div>

              <div class="col-md-9">
                <input class="form-control" type="text" id="brokerEmail" [(ngModel)]="data.buyer.brokerEmail">
                <span class="text-danger">{{ errors.buyer && errors.buyer.brokerEmail }}</span>
              </div>
            </div>

            <div class="row align-items-center m-t-10">
              <div class="col-md-3">
                <label for="typeOfTreaty">
                  {{'ISSUE-TEXT.TYPE-OF-TREATY'|translate}}
                </label>
              </div>

              <div class="col-md-9">
                <input class="form-control" type="text" id="typeOfTreaty" [(ngModel)]="data.buyer.typeOfTreaty">
                <span class="text-danger">{{ errors.buyer && errors.buyer.typeOfTreaty }}</span>
              </div>
            </div>


          </div>

          <div class="col-md-4 offset-md-1 m-t-15">
            <div class="row align-items-center" *ngIf="selectedDocumentType.type != 'receipt_tax_invoice'">
              <div class="col-md-4">
                {{'ISSUE-TEXT.DATE'|translate}}
              </div>

              <div class="col-md-8">  <!-- TODO: fix this element's width -->
                <p-calendar [(ngModel)]="data.date" readonlyInput="true"
                            [showIcon]="true" dateFormat="dd/mm/yy" [locale]="calendarLocale" [yearNavigator]="true"
                            yearRange="2000:2030"></p-calendar>

                <span class="text-danger">{{ errors.document && errors.document.date }}</span>
              </div>
            </div>

            <div class="row align-items-center m-t-10" *ngIf="selectedDocumentType.type == 'invoice'">
              <div class="col-md-4">
                Due Date
              </div>

              <div class="col-md-8">  <!-- TODO: fix this element's width -->
                <p-calendar [(ngModel)]="data.due_date" readonlyInput="true"
                            [showIcon]="true" dateFormat="dd/mm/yy" [locale]="calendarLocale"></p-calendar>

                <span class="text-danger">{{ errors.document && errors.document.due_date }}</span>
              </div>
            </div>

            <div class="row align-items-center m-t-10">
              <div class="col-md-4">
                <label for="documentNo">{{'ISSUE-TEXT.NO'|translate}}</label>
              </div>

              <div class="col-md-8">
                <input class="form-control" type="text" id="documentNo" [(ngModel)]="data.documentNo"
                       (ngModelChange)="checkDocumentNumber() || checkTwoNumberDocumentNumber()">
                <span class="text-danger">{{ errors.document && errors.document.documentNo }}</span>
                <span class="text-danger">{{ duplicateDocumentNumberText || twoNumberDocumentNumberText}}</span>
              </div>
            </div>

            <div class="row align-items-center m-t-10" *ngIf="selectedDocumentType.type == 'receipt_tax_invoice'">
              <div class="col-md-4">
                <label for="reference">{{'ISSUE-TEXT.REF-ID'|translate}}</label>
              </div>
              <div class="col-md-8">
                <p-autoComplete inputId="reference"
                                [suggestions]="refNoList"
                                field="header_invoice_number"
                                [(ngModel)]="data.referenceDocumentID"
                                (onSelect)="selectInvoice($event)"
                                [minLength]="2"
                                appendTo="body"
                                [inputStyle]="{width: '100%'}"
                                class="dv-autocomplete"
                                placeholder="Type to search..."
                                emptyMessage="No invoice found"
                                (completeMethod)="completeInvoiceNo($event,false)"></p-autoComplete>
                <span class="text-danger">{{ errors.document && errors.document.referenceDocumentID }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box-parent">
        <div class="scrollable">
          <table class="table text-center mb-0" id="item-list">
            <thead>
            <tr>
              <th>{{'ISSUE-TEXT.ACTION'|translate}}</th>
              <th></th>
              <th></th>
              <th>{{'ISSUE-TEXT.DESCRIPTION'|translate}}</th>
              <th width="100px">{{'ISSUE-TEXT.QTY'|translate}}</th>
              <th width="12%">{{'ISSUE-TEXT.UNIT-PRICE'|translate}}</th>
              <th width="12%">{{'ISSUE-TEXT.DISCOUNT'|translate}}</th>
              <th width="12%">{{'ISSUE-TEXT.TOTAL'|translate}}</th>
            </tr>
            </thead>

            <tbody>
            <tr *ngFor="let item of data.items; let i = index">
              <td width="1%">
                <button class="ui-button ui-button-icon-only" (click)="addItem(i)">
                  <i class="fa fa-plus"></i>
                </button>

                <button class="ui-button bg-danger border-danger ui-button-icon-only" (click)="removeItem(i)"
                        *ngIf="i !== 0">
                  <i class="fa fa-trash-alt"></i>
                </button>
              </td>

              <td></td>
              <td></td>

              <td>
                <input class="form-control" type="text" [(ngModel)]="item.description" (input)="updateAmount(i)">

                <div class="text-danger">{{ errors.items[i] && errors.items[i].description }}</div>
                <div class="text-danger">{{ errors.items[i] && errors.items[i].qty }}</div>
                <div class="text-danger">{{ errors.items[i] && errors.items[i].unitPrice }}</div>
              </td>

              <td>
                <input class="form-control text-right" type="number" [(ngModel)]="item.qty" (input)="updateAmount(i)">
              </td>

              <td>
                <input class="form-control text-right" type="text" [(ngModel)]="item.unitPrice"
                       (input)="updateAmount(i)">
              </td>

              <td>
                <input class="form-control text-right" type="text" [(ngModel)]="item.discount"
                       (input)="updateAmount(i)">
              </td>

              <td class="text-right">{{ item.amount | currency:' ' }}</td>
            </tr>

            <tr>
              <td colspan="5" class="text-left">{{'ISSUE-TEXT.AMOUNT' | translate}} {{ grandTotalText }}</td>
              <td colspan="2" class="text-right text-bold">{{'ISSUE-TEXT.SUB-TOTAL'|translate}}</td>
              <td class="text-right">{{ total | currency:' ' }}</td>
            </tr>

            <tr>
              <td colspan="5" rowspan="4" class="text-left align-top" style="border-right: 1px solid #dee2e6;">
                <div *ngIf="['invoice'].includes(selectedDocumentType.type)">
                  <p>{{'ISSUE-TEXT.PAYMENT-TERMS' | translate}}</p>
                  <ol class="m-l-2 p-l-15">
                    <li>{{'ISSUE-TEXT.PAYMENT1' | translate }}</li>
                    <li>{{'ISSUE-TEXT.PAYMENT1-1' | translate }}</li>
                    <li>{{'ISSUE-TEXT.PAYMENT1-2' | translate }}</li>
                  </ol>
                </div>
                <div *ngIf="['tax_invoice'].includes(selectedDocumentType.type)">
                  <p>{{'ISSUE-TEXT.TERMS' | translate}}</p>
                  <ul class="m-l-2 p-l-15">
                    <li>{{'ISSUE-TEXT.PAYMENT2' | translate }}</li>
                    <li>{{'ISSUE-TEXT.PAYMENT2-1' | translate }}</li>
                    <li>{{'ISSUE-TEXT.PAYMENT2-2' | translate }}</li>
                  </ul>
                  <div class="row mb-3">
                    <div class="col-3">{{'ISSUE-TEXT.REASON' | translate}}</div>
                    <div class="col-9">
                      <p-dropdown
                        class="dv-dropdown"
                        inputId="purpose"
                        [showClear]="true"
                        [options]="purposes"
                        [(ngModel)]="data.purpose"
                        [autoDisplayFirst]="false"
                        appendTo="body">
                      </p-dropdown>
                    </div>
                  </div>
                  <div class="row" *ngIf="data.purpose === 'other'">
                    <div class="col-3">{{'ISSUE-TEXT.SPECIFY' | translate}}</div>
                    <div class="col-9">
                      <input class="form-control" type="text" [(ngModel)]="data.purposeText">
                      <span class="text-danger">{{ errors.document && errors.document.purposeText }}</span>
                    </div>
                  </div>
                </div>
                <div *ngIf="['receipt', 'receipt_tax_invoice'].includes(selectedDocumentType.type)">
                  <p>{{'ISSUE-TEXT.TERMS' | translate}}</p>
                  <ul class="m-l-2 p-l-15">
                    <li>{{'ISSUE-TEXT.PAYMENT3' | translate}}</li>
                    <li>{{'ISSUE-TEXT.PAYMENT3-1' | translate}}</li>
                    <li>{{'ISSUE-TEXT.PAYMENT3-2' | translate}}</li>
                  </ul>
                </div>
                <div *ngIf="['credit_note', 'debit_note', 'receipt_tax_invoice'].includes(selectedDocumentType.type)">
                  <!--                  <p>{{'ISSUE-TEXT.REMARK' | translate}}</p>-->
                  <table class="table mb-0">

                    <ng-container *ngIf="['credit_note', 'debit_note'].includes(selectedDocumentType.type)">

                      <tr style="height: 1px">
                        <td class="border-0 pl-0" style="width: 1px">{{'ISSUE-TEXT.ORIGINAL-AMOUNT' | translate}}</td>
                        <td class="border-0">
                          <input class="form-control" type="text" [(ngModel)]="originalAmount">
                          <span class="text-danger">{{ errors.document && errors.document.referenceDocumentID }}</span>
                        </td>
                      </tr>

                      <tr style="height: 1px">
                        <td class="border-0 pl-0" style="width: 1px">{{'ISSUE-TEXT.ORIGINAL-VAT' | translate}}</td>
                        <td class="border-0">
                          <input class="form-control" type="text" [(ngModel)]="originalVat">
                          <span class="text-danger">{{ errors.document && errors.document.referenceDocumentID }}</span>
                        </td>
                      </tr>
                      <!--                      <tr style="height: 1px">-->
                      <!--                        <td class="border-0 pl-0" style="width: 1px">{{'ISSUE-TEXT.DIFFERENCE-AMOUNT' | translate}}</td>-->
                      <!--                        <td class="border-0">-->
                      <!--                          <input class="form-control" type="text" [(ngModel)]="differenceAmount">-->
                      <!--                          <span class="text-danger">{{ errors.document && errors.document.referenceDocumentID }}</span>-->
                      <!--                        </td>-->
                      <!--                      </tr>-->
                      <tr style="height: 1px">
                        <td class="border-0 pl-0" style="width: 1px">{{'ISSUE-TEXT.NEW-AMOUNT' | translate}}</td>
                        <td class="border-0 text-right">
                          {{ getNewAmount | currency:' ' }}
                        </td>
                      </tr>

                    </ng-container>

                    <tr style="height: 1px">
                      <td class="border-0 pl-0" style="width: 1px">{{'ISSUE-TEXT.REASON' | translate}}</td>
                      <td class="border-0 ">
                        <p-dropdown
                          class="dv-dropdown"
                          inputId="purpose"
                          [options]="purposes"
                          [(ngModel)]="data.purpose"
                          [autoDisplayFirst]="false"
                          appendTo="body"
                        >
                        </p-dropdown>
                      </td>
                      <div class="text-danger">{{ errors.document && errors.document.purpose }} </div>
                    </tr>
                    <tr *ngIf="data.purpose === 'other'">
                      <td class="border-0 pl-0" style="width: 1px">{{'ISSUE-TEXT.SPECIFY' | translate}}</td>
                      <td class="border-0">
                        <input class="form-control" type="text" [(ngModel)]="data.purposeText">
                        <span class="text-danger">{{ errors.document && errors.document.purposeText }}</span>
                      </td>
                    </tr>
                  </table>
                </div>
              </td>
              <td colspan="2" class="text-right text-bold">{{'ISSUE-TEXT.DISCOUNT'|translate}}</td>
              <td class="text-right">{{ discountTotal | currency:' ' }}</td>
            </tr>

            <tr>
              <td colspan="2" class="text-right text-bold">{{'ISSUE-TEXT.BALANCE'|translate}}</td>
              <td class="text-right">{{ subTotal | currency:' ' }}</td>
            </tr>

            <tr>
              <td class="text-right text-bold">
                <span *ngIf="data.vatType !== 'non-vat'">{{'ISSUE-TEXT.VAT'|translate}} </span>
                <span *ngIf="data.vatType === 'non-vat'">{{'ISSUE-TEXT.NO-VAT'|translate}}</span>
              </td>
              <td>
                <p-dropdown
                  class="dv-dropdown"
                  [options]="vatList"
                  [(ngModel)]="data.vatType"
                  [autoDisplayFirst]="true"
                  appendTo="body"
                >
                </p-dropdown>
              </td>
              <td class="text-right">{{ data.vatType !== 'non-vat' ? (vat | currency:' ') : '-' }}</td>
            </tr>

            <tr>
              <td colspan="2" class="text-right text-bold">{{'ISSUE-TEXT.TOTAL'|translate}}</td>
              <td class="text-right">{{ grandTotal | currency:' ' }}</td>
            </tr>

            <tr *ngIf="['invoice'].includes(selectedDocumentType.type)">
              <td colspan="8" class="text-left pb-0">{{'ISSUE-TEXT.REMARK'}}</td>
            </tr>

            <tr *ngFor="let remark of remarkCount; let j = index">
              <td colspan="7" class="border-0" *ngIf="['invoice'].includes(selectedDocumentType.type)">
                <input class="form-control" type="text" [(ngModel)]="data.remarks.messages[j]">
              </td>
              <td class="border-0" *ngIf="['invoice'].includes(selectedDocumentType.type)">
                <button class="ui-button ui-button-icon-only" (click)="addRemark(j)">
                  <i class="fa fa-plus"></i>
                </button>

                <button class="ui-button bg-danger border-danger ui-button-icon-only" (click)="removeRemark(j)"
                        *ngIf="j !== 0">
                  <i class="fa fa-trash-alt"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="m-t-30 text-center">
    <button class="btn btn-dv btn-clean btn-wide m-r-5" (click)="resetAll()">
      <!-- TODO: change this if want to remove data -->
      <i class="fas fa-chevron-left m-r-5"></i>
      {{'ISSUE-TEXT.BACK' | translate}}
    </button>
    <button class="btn btn-dv btn-wide" (click)="sign()">
      {{'ISSUE-TEXT.NEXT' | translate}}
      <i class="fas fa-chevron-right m-l-5"></i>
    </button>
    <br><br>
    <br><br>
  </div>
</div>

<div *ngIf="step === 3">
  <div class="row justify-content-center">
    <div class="col">
      <h4 class="header">
        {{'TEXT.DOC-IS-EMAIL' | translate}}
      </h4>

      <div class="type-parent text-center">
        <pdf-viewer [src]="result.pdf" [render-text]="true" [show-all]="true"
                    *ngIf="!isLoading && !errors.pdf"></pdf-viewer>

        <span class="text-center text-danger text-bold" *ngIf="!isLoading && errors.pdf">{{ errors.pdf }}</span>

        <app-loading-spinner [isLoading]="isLoading"></app-loading-spinner>
      </div>
    </div>
  </div>

  <div class="m-t-30 text-center" *ngIf="!isLoading">
    <button class="btn btn-dv btn-wide m-r-5" [disabled]="clickPrint || clickSentEmail" (click)="editData()">
      <i class="fas fa-edit m-r-5"></i>
      {{'NORMAL.EDIT' | translate}}
    </button>

    <button class="btn btn-dv btn-clean btn-wide m-r-5" (click)="resetAll()">
      <i class="fas fa-redo m-r-5"></i>
      {{'ISSUE-TEXT.START-OVER' | translate}}
    </button>

    <button class="btn btn-dv btn-wide m-r-5" (click)="print()" *ngIf="!errors.pdf">
      <i class="fas fa-print m-r-5"></i>
      {{'ISSUE-TEXT.PRINT' | translate}}
    </button>

    <button class="btn btn-dv btn-wide" (click)="openMailModal()" *ngIf="!errors.pdf">
      <i class="fas fa-envelope m-r-5"></i>
      {{'ISSUE-TEXT.EMAIL' | translate}}
    </button>
  </div>
</div>

<ng-template #modal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{'ISSUE-TEXT.SEND-EMAIL' |translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeMailModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="!result.message">
      <label for="email">{{'ISSUE-TEXT.PLEASE-EMAIL' | translate}}</label>
      <input class="form-control" type="text" id="email" [(ngModel)]="data.buyer.email">

      <span class="text-danger text-center">{{ errors.email && 'Email ' + errors.email }}</span>
    </div>

    <div *ngIf="result.message" class="text-center">
      <b>{{ result.message }}</b>
    </div>
    <div *ngIf="!result.message">
      <label for="email">{{'ISSUE-TEXT.PLEASE-CC-EMAIL' | translate}}</label>
      <input class="form-control" type="text" id="brokerEmail" [(ngModel)]="data.buyer.brokerEmail">

      <span class="text-danger text-center">{{ errors.cc_email && 'CC Email ' + errors.cc_email }}</span>
    </div>

    <!--    <div *ngIf="result.message" class="text-center">-->
    <!--      <b>{{ result.message }}</b>-->
    <!--    </div>-->
  </div>
  <div class="modal-footer">
    <div class="col-6 text-left" *ngIf="!result.message">
      <button type="button" class="btn btn-dv btn-danger btn-wide" (click)="closeMailModal()">
        {{'ISSUE-TEXT.CANCEL' | translate}}
      </button>
    </div>
    <div class="col-6 text-right p-0">
      <button *ngIf="!result.message" type="button" class="btn btn-dv btn-wide" [disabled]="isSending"
              (click)="sendMail()">
        <i *ngIf="isSending" class="fa fa-spinner fa-spin m-r-5"></i>
        {{ isSending ? 'Sending' : 'Send' }}
      </button>

      <button *ngIf="result.message" type="button" class="btn btn-dv btn-wide" (click)="closeMailModal()">
        {{'ISSUE-TEXT.OK' | translate}}
      </button>
    </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/document-issue.component.html